// deductionActions.ts
import { createAsyncThunk } from '@reduxjs/toolkit';
import { CreateDeductionPayload, UpdateDeductionPayload, DeleteDeductionPayload, FetchDeductionByIdPayload } from './deductionTypes';
import employeeServiceApiInstance from '../../../config/employeeApiConfig';

// Create Deduction
export const createDeduction = createAsyncThunk(
    'deductions/createDeduction',
    async (data: CreateDeductionPayload, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.post('/deduction', data);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to create deduction');
        }
    }
);

// Update Deduction
export const updateDeduction = createAsyncThunk(
    'deductions/updateDeduction',
    async ({ deductionId, ...data }: UpdateDeductionPayload & { deductionId: number }, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.put(`/deduction/${deductionId}`, data);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to update deduction');
        }
    }
);

// Delete Deduction
export const deleteDeduction = createAsyncThunk(
    'deductions/deleteDeduction',
    async ({ deductionId }: DeleteDeductionPayload, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.delete(`/deduction/${deductionId}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to delete deduction');
        }
    }
);

// Fetch Deduction by ID
export const fetchDeductionById = createAsyncThunk(
    'deductions/fetchDeductionById',
    async ({ deductionId }: FetchDeductionByIdPayload, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/deduction/${deductionId}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch deduction');
        }
    }
);

// Fetch All Deductions
export const fetchAllDeductions = createAsyncThunk(
    'deductions/fetchAllDeductions',
    async (_, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get('/deduction');
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch deductions');
        }
    }
);
